import { ValidatorRule } from 'rc-field-form/lib/interface';

export function getFileExtension(file: File) {
  if (!file?.name) return '';
  const nameSplit = file.name.split('.');
  return `.${nameSplit[nameSplit.length - 1]?.toLowerCase()}`;
}

export const translateToMB = (byte: number) => {
  return (byte / 1048576).toFixed(1);
};

export const fileUploadRule: ValidatorRule = {
  validator: (_, value) => {
    if (!value || typeof value === 'string') return Promise.resolve();
    if (Array.isArray(value)) {
      if (value.every(item => item?.id)) {
        return Promise.resolve();
      }
      if (value.some(item => item?.status === 'error')) {
        return Promise.reject("Ошибка");
      }
    }
    if (value.status === 'error') {
      return Promise.reject("Ошибка");
    }
  }
}
